import isEmpty from 'lodash/isEmpty'
import omitBy from 'lodash/omitBy'
import Head from 'next/head'
import { ProductTemplateProp } from 'shared/types'
import { financial } from 'shared/utils/currency-utils'

type ProductTemplateStructuredDataProps = {
  productTemplate: ProductTemplateProp
  locale: string
}

const formatSchema = (obj: object) => JSON.stringify(omitBy(obj, isEmpty))

const ProductTemplateStructuredData = ({
  productTemplate: {
    brandName,
    details,
    isNewInStock,
    name,
    newCount,
    newHighestPrice,
    newLowestPrice,
    offers,
    pictureUrl,
    releaseDate,
    sku,
    story,
  },
  locale,
}: ProductTemplateStructuredDataProps) => {
  if (!isNewInStock) {
    return null
  }

  const currency = locale === 'en-jp' || locale === 'ja-jp' ? 'JPY' : 'USD'

  const schema = {
    '@context': 'http://schema.org',
    '@type': 'Product',
    brand: {
      '@type': 'Brand',
      name: brandName,
    },
    color: details,
    description: story ? story : `${name} - ${brandName}`,
    image: pictureUrl,
    model: name,
    name,
    offers: isNewInStock
      ? {
          '@type': 'AggregateOffer',
          availability: isNewInStock ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock',
          highPrice:
            newHighestPrice && financial({ hideCents: true })(newHighestPrice.localizedValue),
          lowPrice: newLowestPrice && financial({ hideCents: true })(newLowestPrice.localizedValue),
          offerCount: newCount,
          offers: offers
            ? offers.map((offer) => ({
                '@type': 'Offer',
                ...offer,
                priceValidUntil: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
              }))
            : [],
          priceCurrency: currency,
        }
      : null,
    releaseDate: releaseDate.value,
    sku,
  }
  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: formatSchema(schema),
        }}
      />
    </Head>
  )
}

export default ProductTemplateStructuredData
